export default __webpack_public_path__ + "static/transaction-page-request-17b9dd9322cd49dd37d8b90886f9dfce.png";